import css from 'styled-jsx/css';

export default css`
  .Listicle :global(.Figure) {
    margin-bottom: 1.5rem;
  }

  .Listicle :global(.ImageCaption) {
    padding-top: 0.5rem;
  }
`;
